import { Wrench } from 'lucide-react';
import { PhaseStubPage } from '@/components/layout/PhaseStubPage';

export function CalibrationPage() {
  return (
    <PhaseStubPage
      title="Equipment & calibration"
      phase={5}
      modules={[
        'Equipment master with location + status',
        'Calibration history with PDF certificate upload',
        'Due-soon dashboard with email alerts',
        'Out-of-service workflow → removes from production routings',
      ]}
      icon={Wrench}
    />
  );
}
